import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/app/[locale]/branches/industries-overview.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de795977415867/node_modules/next/dist/client/link.js");
